export default "__VITE_ASSET__DemhZ7FD__"